//#region src/kiosk_payment_terminal_model.ts
var KioskPaymentTerminalModel = /* @__PURE__ */ function(KioskPaymentTerminalModel) {
	KioskPaymentTerminalModel[KioskPaymentTerminalModel["None"] = 0] = "None";
	KioskPaymentTerminalModel[KioskPaymentTerminalModel["IngenicoIPP320"] = 1] = "IngenicoIPP320";
	KioskPaymentTerminalModel[KioskPaymentTerminalModel["IngenicoIPP350"] = 2] = "IngenicoIPP350";
	KioskPaymentTerminalModel[KioskPaymentTerminalModel["IngenicoISMP4"] = 3] = "IngenicoISMP4";
	KioskPaymentTerminalModel[KioskPaymentTerminalModel["IngenicoLane3000"] = 4] = "IngenicoLane3000";
	KioskPaymentTerminalModel[KioskPaymentTerminalModel["IngenicoIUC285"] = 5] = "IngenicoIUC285";
	KioskPaymentTerminalModel[KioskPaymentTerminalModel["IngenicoLink2500"] = 6] = "IngenicoLink2500";
	KioskPaymentTerminalModel[KioskPaymentTerminalModel["IngenicoLane3600"] = 7] = "IngenicoLane3600";
	KioskPaymentTerminalModel[KioskPaymentTerminalModel["IngenicoLane5000"] = 8] = "IngenicoLane5000";
	KioskPaymentTerminalModel[KioskPaymentTerminalModel["IngenicoLink2500i"] = 9] = "IngenicoLink2500i";
	KioskPaymentTerminalModel[KioskPaymentTerminalModel["IngenicoLane8000"] = 10] = "IngenicoLane8000";
	KioskPaymentTerminalModel[KioskPaymentTerminalModel["SquareReaderS8"] = 11] = "SquareReaderS8";
	KioskPaymentTerminalModel[KioskPaymentTerminalModel["IngenicoSelf4000"] = 12] = "IngenicoSelf4000";
	KioskPaymentTerminalModel[KioskPaymentTerminalModel["VerifoneMX915"] = 20] = "VerifoneMX915";
	KioskPaymentTerminalModel[KioskPaymentTerminalModel["VerifoneP400"] = 21] = "VerifoneP400";
	KioskPaymentTerminalModel[KioskPaymentTerminalModel["VerifoneE285"] = 22] = "VerifoneE285";
	KioskPaymentTerminalModel[KioskPaymentTerminalModel["VerifoneCM5"] = 23] = "VerifoneCM5";
	KioskPaymentTerminalModel[KioskPaymentTerminalModel["VerifoneP630"] = 24] = "VerifoneP630";
	KioskPaymentTerminalModel[KioskPaymentTerminalModel["BbposWisePosE"] = 31] = "BbposWisePosE";
	KioskPaymentTerminalModel[KioskPaymentTerminalModel["PaxA35"] = 51] = "PaxA35";
	KioskPaymentTerminalModel[KioskPaymentTerminalModel["IngenicoRX5000"] = 60] = "IngenicoRX5000";
	KioskPaymentTerminalModel[KioskPaymentTerminalModel["IngenicoRX7000"] = 61] = "IngenicoRX7000";
	KioskPaymentTerminalModel[KioskPaymentTerminalModel["IngenicoEX8000"] = 62] = "IngenicoEX8000";
	KioskPaymentTerminalModel[KioskPaymentTerminalModel["IngenicoDX8000"] = 63] = "IngenicoDX8000";
	KioskPaymentTerminalModel[KioskPaymentTerminalModel["Unknown"] = 100] = "Unknown";
	return KioskPaymentTerminalModel;
}(KioskPaymentTerminalModel || {});
//#endregion
export { KioskPaymentTerminalModel };

//# sourceMappingURL=kiosk_payment_terminal_model.js.map